import { z } from 'zod';
import { createStandardResponse } from '@/src/shared/data/schemas/responses/base';
import { SChatMember } from './chat-member';
import { SChatMessage } from './chat-message';

export const SChatConversation = z.object({
  id: z.number(),
  recipient: SChatMember,
  unread_message_count: z.number(),
  last_message: SChatMessage.nullable(),
});
export type TChatConversation = z.infer<typeof SChatConversation>;

export const SChatConversationResponse =
  createStandardResponse(SChatConversation);
export type TChatConversationResponse = z.infer<
  typeof SChatConversationResponse
>;

export const SChatConversationsResponse = createStandardResponse(
  z.array(SChatConversation)
);
export type TChatConversationsResponse = z.infer<
  typeof SChatConversationsResponse
>;
